//流程配置 workflow
import Workflows from "@/views/systerm/workflow/Workflows.vue"; //流程配置
import WorkflowInfo from "@/views/systerm/workflow/WorkflowInfo.vue"; //流程配置
import PpmWorkflows from "@/views/systerm/workflow/ppmWorkflows.vue"; //流程配置
import PpmWorkflowInfo from "@/views/systerm/workflow/PpmWorkflowInfo.vue"; //流程配置
import ProjectWorkflows from "@/views/systerm/workflow/projectWorkflows.vue"; //流程配置
import ProjectWorkflowInfo from "@/views/systerm/workflow/projectWorkflowInfo.vue"; //流程配置

export const WorkflowConfig = [
  {
    path: "/workflows",
    name: "Workflows",
    component: Workflows,
  },
  {
    path: "/projectWorkflows",
    name: "ProjectWorkflows",
    component: ProjectWorkflows,
  },
  {
    path: "/ppmWorkflows",
    name: "PpmWorkflows",
    component: PpmWorkflows,
  },
  {
    path: "/workflowInfo",
    name: "WorkflowInfo",
    component: WorkflowInfo,
  },
  {
    path: "/projectWorkflowInfo",
    name: "ProjectWorkflowInfo",
    component: ProjectWorkflowInfo,
  },
  {
    path: "/PpmWorkflowInfo",
    name: "PpmWorkflowInfo",
    component: PpmWorkflowInfo,
  },
];
